import React, { FC } from 'react';
import _find from 'lodash/find';
import FormikSimpleCheckbox from '@minecraft.formik-simple-checkbox';
import CheckboxListWithSearch from '@minecraft.checkbox-list-with-search';
import { useDrawerSearchFilterNameOrCategory, useDrawerFiltersCounts } from '@minecraft.drawer';
import { FilterData, WillingToEnum } from '../../../shared/types';
import { Label } from '../../../shared/styles';
import { FiltersCategoryNameEnum, FiltersCountNameEnum } from '../../shared/types';

type Props = {
  willingToChange: FilterData;
  facialHair: FilterData;
};

const FacialHair: FC<Props> = ({ willingToChange, facialHair }) => {
  const { isSearching, shouldCategoryFilterBeVisible, getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.facialHair
  );
  const { filtersCounts } = useDrawerFiltersCounts();

  const willingToChangeCount =
    _find(filtersCounts?.[FiltersCountNameEnum.willingnessIds], {
      key: WillingToEnum.facialHair,
    })?.docCount || 0;

  return (
    <>
      {isSearching && <Label>{facialHair.label}</Label>}
      {shouldCategoryFilterBeVisible(willingToChange.name) && (
        <FormikSimpleCheckbox name={willingToChange.name} label={willingToChange.label} count={willingToChangeCount} />
      )}
      {shouldCategoryFilterBeVisible(facialHair.name) && (
        <CheckboxListWithSearch
          withFormik
          withSelectAll
          name={facialHair.name}
          options={getMatchedSearchOptions(facialHair.name)}
        />
      )}
    </>
  );
};

export default FacialHair;
